import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import InvestorProfileSectionDisplay
  from 'Views/Page/Content/Templates/InvestorProfilePageTemplate/InvestorProfileSections/InvestorProfileSectionDisplay';

const InvestorProfileSectionLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <InvestorProfileSectionDisplay resource={resource} />
  );
};

InvestorProfileSectionLayout.defaultProps = {};

InvestorProfileSectionLayout.propTypes = {};


export default InvestorProfileSectionLayout;
